(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ModelSymbol', ModelSymbol);

    ModelSymbol.$inject = ['$resource'];

    function ModelSymbol ($resource) {
        var resourceUrl =  'api/model-symbols/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
